import { SupportedLanguage } from '../components/types/gopay'

export function getCurrentLanguage() {
  if (process.env.REACT_APP_LANG && process.env.REACT_APP_LANG in SupportedLanguage) {
    return process.env.REACT_APP_LANG as SupportedLanguage
  }

  return SupportedLanguage.CS
}
